import DataTableButton from "@/components/data-table/components/DataTableButton";
import { CollapsibleTrigger } from "@/components/ui/collapsible";
import { formatNumber } from "@/lib/utils/formatters";
import { ReadShiftReport } from "@/types/shiftReport";
import { ChevronRight } from "lucide-react";
import { MouseEventHandler, useCallback } from "react";

interface ShiftReportExpandCellProps {
  data: ReadShiftReport;
  onClick(data: ReadShiftReport | null): void;
  isActive: boolean;
}

const ShiftReportExpandCell = ({
  data,
  onClick,
  isActive,
}: ShiftReportExpandCellProps) => {
  const onCellClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      e.stopPropagation();
      onClick(isActive ? null : data);
    },
    [data, isActive, onClick],
  );

  return (
    <CollapsibleTrigger onClick={onCellClick} asChild>
      <DataTableButton>
        {mapEntriesToReadableRecords(data)}
        <ChevronRight className="h-4 w-4" />
      </DataTableButton>
    </CollapsibleTrigger>
  );
};

export default ShiftReportExpandCell;

const mapEntriesToReadableRecords = (data: ReadShiftReport) => {
  const { department_entries } = data;
  return department_entries
    .map((entry, index, array) => {
      const { department_name, ordered, present } = entry;
      const entryText = `${department_name}: ${formatNumber(ordered)} / ${formatNumber(present)}`;

      return index === array.length - 1 ? entryText : `${entryText}, `;
    })
    .join("");
};
